import { parse } from 'graphql';

import type { RetentionLinkType } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

type GetGeneratedLinkQuery = {
  getGeneratedLink: RetentionLinkType | null;
};

type GetGeneratedLinkQueryVariables = {
  callerId: string;
};

const getGeneratedLinkDocument = parse(`
  query GetGeneratedLink($callerId: String!) {
    getGeneratedLink(callerId: $callerId) {
      autoDeactivatePerformedAt
      autoDeactivateScheduledAt
      callerId
      callerResolution
      callerResolvedAt
      createdAt
      createdBy
      emailSentAt
      id
      link
      smsSentAt
      updatedAt
    }
  }
`);

export const getGeneratedLink = async (callerId: string) => {
  const response = await queryExecute<GetGeneratedLinkQuery, GetGeneratedLinkQueryVariables>({
    query: getGeneratedLinkDocument,
    variables: {
      callerId,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.getGeneratedLink;
};
